import { useRef, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";

export const useLogout = () => {
  const navigate = useNavigate();
  const { loggedInUser, authInitialized } = useAuth();

  const [openModal, setOpenModal] = useState(false);
  const hasHandledExpiry = useRef(false);

  useEffect(() => {
    if (!authInitialized) return;

    if (!loggedInUser && !hasHandledExpiry.current) {
      hasHandledExpiry.current = true;
      setOpenModal(true);
    }
  }, [loggedInUser, authInitialized]);

  const confirmLogout = useCallback(() => {
    setOpenModal(false);
    hasHandledExpiry.current = false;

    sessionStorage.clear();
    localStorage.removeItem("royal-token");

    navigate("/");
  }, [navigate]);

  return {
    openModal,
    confirmLogout,
  };
};
